module.exports = __webpack_public_path__ + "static/media/logo.2fd48a92.png";